import React from 'react';
import './summaryBox.scss';
import jquery from 'jquery';

import AccordionMultipleProducts from '../../Accordion/AccordionMultipleProducts';

/** @import {WithFeatureFlagsProps} from '../../FeatureFlags/FeatureFlagsTypes' */
/** @import {SummaryBoxProps} from './SummaryBoxTypes' */

const onExpandAccordion = (/** @type {{ target: HTMLInputElement | null; }} */ {target}) => {
    setTimeout(() => {
        const rect = target?.getBoundingClientRect();
        const scrollTop = document.documentElement.scrollTop;
        const targetPosition = (rect?.top || 0) + scrollTop;
        console.log(rect, scrollTop, targetPosition)

        jquery("html, body").animate({scrollTop: targetPosition}, 400);
    }, 450);

};

function SummaryBox(/** @type {WithFeatureFlagsProps & SummaryBoxProps} */ {data, products, featureEnabled}) {
 
    return (
        <section className='summary-box'>

            <div className='summary-box__anchor' id="summary-box" />

            <h3 className='summary-box__heading'>Summary box - everything you need to know</h3>

            <div className='summary-box__accordion'>
                <AccordionMultipleProducts 
                    items={data} 
                    products={products} 
                    featureEnabled={featureEnabled} 
                    onExpand={onExpandAccordion}
                />
            </div>

        </section>
    );
};

export default SummaryBox;
